
import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer id="contact" className="footer">

      <div className="footer-container">

        <div className="footer-grid">

          <div className="footer-brand">

            <h2>REASONABLE</h2>
            <span>SERVICES</span>

            <p>
              Professional mobile car wash,
              house cleaning and Airbnb cleaning
              services in Cape Town.
            </p>

          </div>

          <div className="footer-links">

            <h3>Quick Links</h3>

            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/">Services</a></li>
              <li><a href="/">Gallery</a></li>
              <li><a href="/">About</a></li>
              <li><a href="/">Contact</a></li>
            </ul>

          </div>

          <div className="footer-services">

            <h3>Services</h3>

            <ul>
              <li>Mobile Car Wash</li>
              <li>House Cleaning</li>
              <li>Airbnb Cleaning</li>
              <li>Deep Cleaning</li>
            </ul>

          </div>

          <div className="footer-contact">

            <h3>Contact</h3>

            <p>📍 Muizenberg, Cape Town</p>
            <p>📞 +27 76 720 1554</p>
            <p>✉️ info@reasonableservices.co.za</p>

            <a
              href="https://wa.me/27767201554"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-btn"
            >
              WhatsApp Us
            </a>

          </div>

        </div>

        <div className="footer-bottom">
          <p>
            © 2026 Reasonable Services.
            All Rights Reserved.
          </p>
        </div>

      </div>

    </footer>
  );
}

export default Footer;

